import React from 'react';

import NavLink from './NavLink';

export default () => (
  <NavLink to="/login">
    Logga in
  </NavLink>
);
